import React from 'react';
import { MoreHorizontal, ClipboardList, UserCheck, Truck, MapPin, ShieldCheck, Building2, Shield, Landmark, Activity, Search, Scale, BarChart3, AlertTriangle, Brain } from 'lucide-react';
export function Phase2Slide() {
  const platforms = [{
    name: 'Talabat',
    logo: 'https://cdn.magicpatterns.com/uploads/7756UG5Jym81A2wQ5NTmPg/Talabat_Logo.jpg'
  }, {
    name: 'Careem',
    logo: 'https://cdn.magicpatterns.com/uploads/7xRrJrg1q6oHJyA6jgCB5f/careem_logo.jpg'
  }, {
    name: 'Amazon',
    logo: 'https://cdn.magicpatterns.com/uploads/5ovEx7PeQYHdqRHWJccm3E/amazon_logo.jpg'
  }, {
    name: 'Noon',
    logo: 'https://cdn.magicpatterns.com/uploads/tD7MZW9eSLEFkb5TBBWD9M/noon_logo.png'
  }, {
    name: 'Other Platforms',
    icon: <MoreHorizontal className="w-5 h-5 text-gray-500" data-id="element-338" />
  }];
  const coreModules = [{
    name: 'Order Data',
    desc: 'Customer name, phone, items, bill, payment method',
    icon: <ClipboardList className="w-4 h-4 text-[#2EBCB0]" data-id="element-339" />
  }, {
    name: 'Driver Assignment',
    desc: 'Driver linked to order',
    icon: <UserCheck className="w-4 h-4 text-[#2EBCB0]" data-id="element-340" />
  }, {
    name: 'Vehicle Matching',
    desc: 'Vehicle data from Pair2 system',
    icon: <Truck className="w-4 h-4 text-[#2EBCB0]" data-id="element-341" />
  }, {
    name: 'Live Tracking',
    desc: 'Real-time movement',
    icon: <MapPin className="w-4 h-4 text-[#2EBCB0]" data-id="element-342" />
  }, {
    name: 'Compliance Engine',
    desc: 'Rules, validation, enforcement',
    icon: <ShieldCheck className="w-4 h-4 text-[#2EBCB0]" data-id="element-343" />
  }];
  const authorities = [{
    name: 'Transport Authority',
    icon: <Building2 className="w-5 h-5 text-gray-700" data-id="element-344" />
  }, {
    name: 'Police',
    icon: <Shield className="w-5 h-5 text-gray-700" data-id="element-345" />
  }, {
    name: 'Other Authorities',
    icon: <Landmark className="w-5 h-5 text-gray-700" data-id="element-346" />
  }];
  const capabilities = [{
    name: 'Real-Time Monitoring',
    icon: <Activity className="w-3.5 h-3.5" data-id="element-347" />
  }, {
    name: 'Investigation & Tracking',
    icon: <Search className="w-3.5 h-3.5" data-id="element-348" />
  }, {
    name: 'Compliance Enforcement',
    icon: <Scale className="w-3.5 h-3.5" data-id="element-349" />
  }, {
    name: 'Data Insights',
    icon: <BarChart3 className="w-3.5 h-3.5" data-id="element-350" />
  }];
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-8 py-6" data-id="element-351">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-352">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-353" />
      </div>

      {/* Title */}
      <div className="text-center shrink-0 mb-4 mt-1" data-id="element-354">
        <span className="text-xs font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-355">
          Phase 2
        </span>
        <h1 className="text-[1.25rem] font-bold text-[#1a1a2e] mt-1" data-id="element-356">
          National Delivery Data Integration Layer
        </h1>
      </div>

      {/* Main Architecture Diagram - Vertical Flow */}
      <div className="flex-grow flex flex-col items-center justify-between max-w-7xl mx-auto w-full relative py-2" data-id="element-357">
        {/* TOP LAYER: Platforms */}
        <div className="w-full flex flex-col items-center z-10" data-id="element-358">
          <h2 className="text-[0.65rem] font-semibold text-gray-500 uppercase tracking-wider mb-3 bg-white px-3" data-id="element-359">
            Delivery Platforms & Marketplaces
          </h2>
          <div className="flex items-center justify-center gap-4 w-full" data-id="element-360">
            {platforms.map((platform, idx) => <div key={idx} className="flex items-center gap-2.5 bg-white border border-gray-200 rounded-xl px-3 py-2 shadow-sm hover:shadow-md transition-shadow relative w-40 justify-center" data-id="element-361">
                <div className="w-7 h-7 rounded-md overflow-hidden border border-gray-100 flex items-center justify-center bg-gray-50 shrink-0" data-id="element-362">
                  {platform.logo ? <img src={platform.logo} alt={platform.name} className="w-full h-full object-cover" data-id="element-363" /> : platform.icon}
                </div>
                <span className="font-medium text-[0.75rem] text-gray-800 whitespace-nowrap" data-id="element-364">
                  {platform.name}
                </span>
                {/* Connection point */}
                <div className="absolute bottom-0 left-1/2 w-1.5 h-1.5 bg-gray-300 rounded-full -translate-x-1/2 translate-y-1/2" data-id="element-365"></div>
              </div>)}
          </div>
        </div>

        {/* SVG CONNECTIONS: Top to Middle */}
        <div className="w-full h-16 relative shrink-0 -my-2 z-0" data-id="element-366">
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1000 100" preserveAspectRatio="none" data-id="element-367">
            <defs data-id="element-368">
              <marker id="arrowhead-down" markerWidth="6" markerHeight="4" refX="3" refY="4" orient="auto" data-id="element-369">
                <polygon points="0 0, 6 0, 3 4" fill="#2EBCB0" data-id="element-370" />
              </marker>
            </defs>
            {/* 5 lines converging from top (x: 150, 325, 500, 675, 850) to center bottom (x: 500) */}
            {[150, 325, 500, 675, 850].map((x, i) => <g key={i} data-id="element-371">
                <path d={`M ${x} 0 C ${x} 50, 500 50, 500 100`} fill="none" stroke="#2EBCB0" strokeWidth="1.5" opacity="0.15" data-id="element-372" />
                <path d={`M ${x} 0 C ${x} 50, 500 50, 500 100`} fill="none" stroke="#2EBCB0" strokeWidth="2" strokeDasharray="6 10" opacity="0.6" markerEnd="url(#arrowhead-down)" className="flow-down" style={{
              animationDelay: `${i * 0.15}s`
            }} data-id="element-373" />
              </g>)}
          </svg>
        </div>

        {/* MIDDLE LAYER: Pair2 Core */}
        <div className="w-full max-w-3xl flex flex-col items-center z-10 relative" data-id="element-374">
          <div className="text-center mb-2 absolute -top-6 left-0 right-0 z-20" data-id="element-375">
            <span className="text-[0.65rem] font-semibold text-[#2EBCB0] uppercase tracking-wider bg-white px-3 py-0.5 rounded-full border border-[#2EBCB0]/20 shadow-sm" data-id="element-376">
              Unified National Data Layer
            </span>
          </div>

          <div className="bg-white border border-[#2EBCB0]/30 rounded-2xl shadow-lg w-full relative flex flex-col" data-id="element-377">
            <div className="p-5 flex flex-col h-full" data-id="element-378">
              <div className="flex items-center justify-center gap-3 mb-4 pb-3 border-b border-gray-100" data-id="element-379">
                <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2" className="h-6" data-id="element-380" />
                <h3 className="text-lg font-bold text-[#1a1a2e]" data-id="element-381">
                  National Platform
                </h3>
              </div>

              <div className="flex items-stretch justify-between gap-3" data-id="element-382">
                {coreModules.map((mod, idx) => <div key={idx} className="flex flex-col items-center text-center flex-1 bg-[#2EBCB0]/5 rounded-lg px-2 py-2.5" data-id="element-383">
                    <div className="shrink-0 p-1.5 bg-[#2EBCB0]/10 rounded-md mb-1.5" data-id="element-384">
                      {mod.icon}
                    </div>
                    <h4 className="font-semibold text-[0.7rem] text-[#1a1a2e] mb-0.5 leading-tight" data-id="element-385">
                      {mod.name}
                    </h4>
                    <p className="text-[0.6rem] text-gray-500 leading-tight" data-id="element-386">
                      {mod.desc}
                    </p>
                  </div>)}
              </div>
            </div>

            {/* Connection points */}
            <div className="absolute top-0 left-1/2 w-2 h-2 bg-[#2EBCB0] rounded-full -translate-x-1/2 -translate-y-1 border-2 border-white" data-id="element-387"></div>
            <div className="absolute bottom-0 left-1/2 w-2 h-2 bg-[#2EBCB0] rounded-full -translate-x-1/2 translate-y-1 border-2 border-white" data-id="element-388"></div>
          </div>

          {/* AI-Powered Control Box (Left) */}
          <div className="absolute -left-4 top-1/2 -translate-y-1/2 -translate-x-full w-48 bg-[#2EBCB0]/5 border border-[#2EBCB0]/30 rounded-lg p-3 flex flex-col gap-1.5 shadow-sm" data-id="element-389">
            <div className="flex items-center gap-1.5 text-[#2EBCB0] mb-1" data-id="element-390">
              <Brain className="w-3.5 h-3.5" data-id="element-391" />
              <span className="text-[0.65rem] font-semibold uppercase tracking-wider" data-id="element-392">
                AI-Powered Control
              </span>
            </div>
            <span className="text-[0.7rem] text-[#1a1a2e] flex items-center gap-1.5" data-id="element-393">
              <div className="w-1.5 h-1.5 rounded-full bg-[#2EBCB0]" data-id="element-394"></div>{' '}
              Real-Time Risk Detection
            </span>
            <span className="text-[0.7rem] text-[#1a1a2e] flex items-center gap-1.5" data-id="element-395">
              <div className="w-1.5 h-1.5 rounded-full bg-[#2EBCB0]" data-id="element-396"></div>{' '}
              Automated Decision Engine
            </span>
            <span className="text-[0.7rem] text-[#1a1a2e] flex items-center gap-1.5" data-id="element-397">
              <div className="w-1.5 h-1.5 rounded-full bg-[#2EBCB0]" data-id="element-398"></div>{' '}
              Predictive Insights
            </span>
          </div>

          {/* Advanced Intelligence Box (Right) */}
          <div className="absolute -right-4 top-1/2 -translate-y-1/2 translate-x-full w-48 bg-[#2EBCB0]/5 border border-[#2EBCB0]/30 rounded-lg p-3 flex flex-col gap-1.5 shadow-sm" data-id="element-399">
            <div className="flex items-center gap-1.5 text-[#2EBCB0] mb-1 whitespace-nowrap" data-id="element-400">
              <AlertTriangle className="w-3.5 h-3.5 shrink-0" data-id="element-401" />
              <span className="text-[0.6rem] font-semibold uppercase tracking-wider" data-id="element-402">
                Advanced Intelligence
              </span>
            </div>
            <span className="text-[0.7rem] text-[#1a1a2e] flex items-center gap-1.5" data-id="element-403">
              <div className="w-1.5 h-1.5 rounded-full bg-[#2EBCB0]" data-id="element-404"></div>{' '}
              Fraud Detection
            </span>
            <span className="text-[0.7rem] text-[#1a1a2e] flex items-center gap-1.5" data-id="element-405">
              <div className="w-1.5 h-1.5 rounded-full bg-[#2EBCB0]" data-id="element-406"></div> Cash
              Tracking
            </span>
            <span className="text-[0.7rem] text-[#1a1a2e] flex items-center gap-1.5" data-id="element-407">
              <div className="w-1.5 h-1.5 rounded-full bg-[#2EBCB0]" data-id="element-408"></div>{' '}
              Suspicious Behavior Alerts
            </span>
          </div>
        </div>

        {/* SVG CONNECTIONS: Middle to Bottom */}
        <div className="w-full h-16 relative shrink-0 -my-2 z-0" data-id="element-409">
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1000 100" preserveAspectRatio="none" data-id="element-410">
            {/* 3 lines diverging from center top (x: 500) to bottom (x: 300, 500, 700) */}
            {[300, 500, 700].map((x, i) => <g key={i} data-id="element-411">
                <path d={`M 500 0 C 500 50, ${x} 50, ${x} 100`} fill="none" stroke="#2EBCB0" strokeWidth="1.5" opacity="0.15" data-id="element-412" />
                <path d={`M 500 0 C 500 50, ${x} 50, ${x} 100`} fill="none" stroke="#2EBCB0" strokeWidth="2" strokeDasharray="6 10" opacity="0.6" markerEnd="url(#arrowhead-down)" className="flow-down" style={{
              animationDelay: `${i * 0.2}s`
            }} data-id="element-413" />
              </g>)}
          </svg>
        </div>

        {/* BOTTOM LAYER: Authorities */}
        <div className="w-full flex flex-col items-center z-10" data-id="element-414">
          <h2 className="text-[0.65rem] font-semibold text-gray-500 uppercase tracking-wider mb-3 bg-white px-3" data-id="element-415">
            Government Authorities & Control
          </h2>
          <div className="flex items-center justify-center gap-6 w-full mb-4" data-id="element-416">
            {authorities.map((auth, idx) => <div key={idx} className="flex flex-col items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 relative w-44 shadow-sm" data-id="element-417">
                {/* Connection point */}
                <div className="absolute top-0 left-1/2 w-1.5 h-1.5 bg-gray-300 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-418"></div>

                <div className="bg-white p-2 rounded-lg border border-gray-100 shadow-sm" data-id="element-419">
                  {auth.icon}
                </div>
                <span className="font-semibold text-[0.75rem] text-[#1a1a2e] text-center leading-tight" data-id="element-420">
                  {auth.name}
                </span>
              </div>)}
          </div>

          {/* Capabilities Row */}
          <div className="flex items-center justify-center gap-4 flex-wrap max-w-3xl" data-id="element-421">
            {capabilities.map((cap, idx) => <div key={idx} className="flex items-center gap-1.5 bg-[#2EBCB0]/10 px-3 py-1.5 rounded-full border border-[#2EBCB0]/20" data-id="element-422">
                <span className="text-[#2EBCB0]" data-id="element-423">{cap.icon}</span>
                <span className="text-[0.65rem] font-semibold text-[#1a1a2e]" data-id="element-424">
                  {cap.name}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {/* Bottom Tagline */}
      <div className="text-center shrink-0 mt-2" data-id="element-425">
        <p className="text-[0.8rem] italic text-gray-500 font-medium" data-id="element-426">
          "Every delivery becomes a fully traceable, verified, and controlled
          transaction."
        </p>
      </div>
    </div>;
}